/* eslint-disable no-console*/

import { useTheme } from '@mui/system';

/**
 * Returns the current Interstate Theme
 */
export const useInterstateTheme = () => {
  const errorMsg = "ERROR: useInterstateTheme didn't find a theme.  Check to be sure that the component is wrapped with an InterstateThemeProvider instance";
  const theme = useTheme();
  if (!theme?.tokens) {
    if (process?.env?.NODE_ENV === 'production') {
      console.error(errorMsg);
    } else {
      throw new Error(errorMsg);
    }
  }
  return theme;
};